import { render, staticRenderFns } from "./StButton.vue?vue&type=template&id=8dbded62&"
import script from "./StButton.vue?vue&type=script&lang=js&"
export * from "./StButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports